import {HTTP_INTERCEPTORS} from '@angular/common/http';
import {DefaultInterceptor} from './default-interceptors';

export const HttpInterceptorProviders = [
    // { provide: HTTP_INTERCEPTORS, useClass: DefaultInterceptor,multi:true}
]
